module.exports = __webpack_public_path__ + "img/Kinesio-Taping.ea877dcc.jpg";